var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cooperation-suspended d-flex justify-center white--text font-weight-bold py-1"},[_c('span',[_vm._v(_vm._s(_vm.$t('cooperationSuspended.title')))])])}
var staticRenderFns = []

export { render, staticRenderFns }